<template>
  <div class="flex flex-col gap-4" v-if="posts.length">
    <AtomBlockHeaderSeo 
      :label="$t('city.start.cornerstone.label', { city: fat.city?.name })"
      :heading="$t('city.start.cornerstone.heading', { city: fat.city?.name })"
    />
    <div class="grid grid-cols-12 gap-x-4 gap-y-10 md:gap-x-8" v-if="posts?.length" v-auto-animate>
      <div class="col-span-full sm:col-span-6 xl:col-span-4" v-for="post in posts" :key="post.id">
        <NuxtLink :to="post.path" class="block">
          <PostsCard :post="post" />
        </NuxtLink>
      </div>
    </div>
    <NuxtLink class="flex items-center gap-2" :to="`/${$t('routes.guides')}/${fat.city?.slug}`" v-if="fat.city.sections?.includes('guides')">
      <div class="w-5 h-5 flex items-center justify-center rounded-full bg-sky text-ocean">
        <AtomIcon name="chevron-right" class="text-sm" />
      </div>
      <div class="text-sm">{{ $t('shared.showMoreGuides') }}</div>
    </NuxtLink>
  </div>
</template>

<script setup>
const app = useAppStore()
const fat = useFatStore()

const props = defineProps({
  posts: {
    type: Array,
    default: () => []
  },
})
</script>